(function ($) {
	'use strict';

	$(function () {
		const mapForm = document.querySelector('.js-map-form');

		if (mapForm) {
		 	const mapFormSelect = mapForm.querySelector('.js-map-form-select');
			const mapUrl = mapForm.dataset.mapPage;

		 	mapForm.addEventListener('submit', function (e) {
				e.preventDefault();

				const selectedValue = mapFormSelect.options[mapFormSelect.selectedIndex].value;

				if (selectedValue === '') {
					window.location.href = mapUrl;
				} else {
					window.location.href = `${mapUrl}?country=${selectedValue}`;
				}
		 	});
		}
	});
})(jQuery);
